import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Select } from '@cimpress/react-components';
import ErrorText from './Shared/ErrorText';
import { SELLER_TYPE } from '../../../../constants/priceArchs';

class SelectField extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    input: PropTypes.object.isRequired,
    label: PropTypes.string.isRequired,
    meta: PropTypes.object.isRequired,
    options: PropTypes.arrayOf(PropTypes.object).isRequired,
    onChange: PropTypes.func,
    sellerNameCallback: PropTypes.func
  };

  onChange = value => {
    const { onChange } = this.props;

    if (value && value.type.toLowerCase() === SELLER_TYPE.toLowerCase()) {
      const { sellerNameCallback } = this.props;
      sellerNameCallback(value);
    }
    this.props.input.onChange(value);

    onChange && onChange(value);
  };

  render() {
    const { className, input, label, meta, options, sellerMigratedClass, t } = this.props;

    return (
      <div className={className}>
        <Select
          {...input}
          onChange={this.onChange}
          label={label}
          options={options}
          className={sellerMigratedClass ? sellerMigratedClass : null}
        />
        {sellerMigratedClass ? (
          <div style={{ marginTop: '0px !important', paddingTop: '0px !important', display: 'flex', zIndex: '100' }}>
            <span className="help-block" style={{ paddingRight: '5px !important' }}>
              {t('createContract:getStarted.sellerInPricingArchV2Message')}
            </span>
            <a
              href={`${process.env.REACT_APP_PRICINGMANAGER_V2_URL}`}
              className="help-block"
              style={{ textDecoration: 'underline' }}>
              Pricing Manager V2
            </a>
          </div>
        ) : null}
        {meta.touched && meta.error && <ErrorText text={meta.error} />}
      </div>
    );
  }
}

export default SelectField;
